"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var classNames = require("classnames");
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_types_1 = require("@caddigital/sok-types");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var components_1 = require("components");
var list_1 = require("utils/list");
var dispatchers_1 = require("../../utils/dispatchers");
var __1 = require("../../../..");
var ConfirmationComponents_1 = require("../ConfirmationComponents");
var createRowCell = function (item) {
    return function (_a) {
        var _b;
        var key = _a[0], column = _a[1];
        var value = item[key];
        var width = (_b = column === null || column === void 0 ? void 0 : column.pixelWidth) !== null && _b !== void 0 ? _b : 0;
        return (React.createElement("div", { key: key.toLowerCase(), className: "row__column", style: (0, list_1.createCellStyle)(width) },
            React.createElement("div", null, value)));
    };
};
var ListRowComponent = function (_a) {
    var index = _a.index, data = _a.data, style = _a.style;
    var vektorioProject = React.useContext(__1.CurrentVektorioProject);
    var _b = React.useState(), currentItemAction = _b[0], setCurrentItemAction = _b[1];
    var _c = React.useState(null), currentItem = _c[0], setCurrentItem = _c[1];
    var _d = (0, react_redux_1.useSelector)(function (state) { return ({
        currentProject: state.project.currentProject.project,
        isModalOpen: state.vektorio.detachFolders.isModalOpen
    }); }), currentProject = _d.currentProject, isModalOpen = _d.isModalOpen;
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var item = data.items[index];
    var createCell = createRowCell(item);
    var resyncFolder = function (folder) {
        var folderUuid = folder.folderUuid;
        dispatchers.resyncFolders({
            folderUuid: folderUuid,
            projects: {
                sokopro: currentProject.uuid,
                vektorio: vektorioProject.vektorioId
            }
        });
    };
    var unlinkFolder = function (id, mode) {
        dispatchers.unlinkFolder({
            project: currentProject,
            vektorioProject: vektorioProject,
            body: [{ folderId: id, mode: mode }]
        });
    };
    var handleIconClick = function (action) {
        setCurrentItemAction(action);
        setCurrentItem(item);
        if (item.folderId.length !== 0) {
            dispatchers.toggleModal();
        }
    };
    return (React.createElement("div", { className: "row", style: style },
        Object.entries(data.columns).map(createCell),
        React.createElement("div", { className: "row-actions" },
            React.createElement(components_1.TableRowIcon, { icon: classNames('fa-sync', 'resync-icon', item.folderSyncStatus), disabled: item.folderSyncStatus === sok_types_1.Vektorio.VektorioSyncStatus.IN_PROGRESS ||
                    item.folderSyncStatus === sok_types_1.Vektorio.VektorioSyncStatus.PENDING, title: (0, translation_1.getLocalization)("vektorio/linkedFolders/tooltips/resync/".concat(item.folderSyncStatus)), onClick: function () { return handleIconClick('resync'); } }),
            React.createElement(components_1.TableRowIcon, { icon: "fa-times-circle remove-icon", onClick: function () { return handleIconClick('unlink'); } })),
        currentItem && currentItemAction && (React.createElement(components_1.ConfirmDialog, { overlayClassName: "generic-warning-confirmation-modal", isOpen: isModalOpen, close: dispatchers.toggleModal, header: (0, translation_1.getLocalization)(currentItemAction === 'resync'
                ? 'genericWarningConfirmationModal/pleaseConfirm'
                : 'genericWarningConfirmationModal/warning'), body: React.createElement(ConfirmationComponents_1.ConfirmationContext, { action: currentItemAction, name: currentItem.sokopro }), footer: React.createElement(ConfirmationComponents_1.ConfirmationButtons, { actionHandler: currentItemAction === 'resync'
                    ? function () { return resyncFolder(currentItem); }
                    : function () {
                        return unlinkFolder(Number(currentItem.folderId), currentItem.mode);
                    }, setIsModalOpen: dispatchers.toggleModal }) }))));
};
exports.ListRow = React.memo(ListRowComponent);
